import React from 'react';
import { Button } from 'react-bootstrap';

interface HelpButtonProps {
  className?: string;
  variant?: string;
  size?: "sm" | "lg";
  title?: string;
}

const HelpButton: React.FC<HelpButtonProps> = ({ 
  className = "", 
  variant = "primary",
  size,
  title = "Chat"
}) => {
  const handleClick = () => {
    if ((window as any).openZendesk) {
      (window as any).openZendesk();
    } else {
      console.warn('Zendesk is not available');
    }
  };

  return (
    <Button 
      variant={variant}
      size={size}
      className={`${className}`}
      onClick={handleClick}
      title={title}
    >
     <i className="fa fa-comment"></i>Chat
    </Button>
  );
};

export default HelpButton;